export const DUMMY_POST2 = [
    {
        id: "1",
        lessonName: 'Sentence Dictation',
        class: 1,
        deadline: '20/02/2023'
    },

    {
        id: "2",
        lessonName: 'Picture Description',
        class: 2,
        deadline: '20/02/2023'
    },

    {
        id: "3",
        lessonName: 'Story Telling',
        class: 3,
        deadline: '22/05/2023'
    },
    {
        id: "4",
        lessonName: 'Sentence Dictation',
        class: 4,
        deadline: '10/04/2023'
    },
]